import Vue from 'vue'

export default function () {
  return Vue.ApiAdapter
}



// WEBPACK FOOTER //
// ./src/repositories/ApiClient.js